import { memo } from 'react';
import Navbar from 'src/components/NavBar';
import { useContextSelector } from 'use-context-selector';
import { InvoiceContext } from './InvoiceDetailsContext';

const InvoiceDetailsNavBar = () => {
  const type = useContextSelector(InvoiceContext, (value) => value.type);
  const invoice = useContextSelector(InvoiceContext, (value) => value.invoice);
  const lineItemsWithErrorWarningStatus = useContextSelector(
    InvoiceContext,
    (value) => value.lineItemsWithErrorWarningStatus
  );

  return (
    <Navbar
      title={
        invoice && Object.keys(invoice).length && lineItemsWithErrorWarningStatus.length
          ? type === 'invoice'
            ? 'Invoice Details'
            : 'Credit Memo Details'
          : 'Invoice Details'
      }
    />
  );
};

export default memo(InvoiceDetailsNavBar);
